import React, {useEffect, useRef, useState} from "react";
import withStyles from "@material-ui/core/styles/withStyles";

import NavPills from "components/NavPills/NavPills.jsx";
import Button from "components/CustomButtons/Button.jsx";

import feedbackStyle from "assets/jss/material-dashboard-pro-react/views/pdpeStyle";
import SweetAlert from "../../components/SweetAlertWrapper";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faInfoCircle} from "@fortawesome/free-solid-svg-icons";
import Parser from "html-react-parser";
import CustomInput from "../../components/CustomInput/CustomInput";
import Accordion from "../../components/Accordion/Accordion";
import Checkbox from "@material-ui/core/Checkbox";
import Check from "@material-ui/icons/Check";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Datetime from "../../components/DatetimeWrapper";
import FormControl from "@material-ui/core/FormControl";

function FormularioGenerico({formulario, valores_defeito, classes, onChange, onSubmit, extra, ...props}) {
  const [valores, setValores] = useState(valores_defeito || {});
  const [etapa, setEtapa] = useState(0);
  const [modal, setModal] = useState(null);
  const dirty = useRef(false);

  useEffect(() => {
    if (dirty.current)
      onChange && onChange(valores);
  }, [valores]);

  useEffect(() => {
    setValores(valores_defeito || {});
  }, [valores_defeito]);

  function prevNav() {
    setEtapa(etapa - 1);
  }

  function nextNav() {
    setEtapa(etapa + 1);
  }

  function submitAnswers() {
    onSubmit && onSubmit(valores);
  }

  function hideModal() {
    setModal(null);
  }

  function openInfo(questao) {
    setModal(<SweetAlert
      style={{width: 700}}
      title={""}
      onConfirm={() => hideModal()}
      confirmBtnText="Ok"
      confirmBtnCssClass={classes.button + " " + classes.primary + " " + classes.buttonConfirm}
      cancelBtnCssClass={classes.button}>
      <h5>{questao.designacao}</h5>
      <div className={classes.infoModalContainer}>
        {questao.detalhe.map(d => <>
          <h4>{d.titulo}</h4>
          <p>{Parser(d.texto.split("\n").join("<br/>"))}</p>
        </>)}
      </div>
    </SweetAlert>)
  }

  if (!formulario) return null;

  let content = [];
  formulario.etapas.forEach(({titulo, legenda, instrucoes, config, questoes, ...etapa}, idx_etapa) => {
    config = {...formulario.config, ...config};

    content.push({
      tabButton: "" + (idx_etapa + 1),
      tabContent: (<div className={classes.questoes}>
        <h3>{titulo}</h3>
        <div className={classes.questaoHeader}>
          <h4>{legenda}</h4>
          {instrucoes && <h6 style={{paddingBottom: "10px"}}>{instrucoes}</h6>}
          {questoes.map(({config: configQuestao, ...questao}, idx_questao) => {
            configQuestao = {...config, ...configQuestao};

            function guardarValor(key, valor, chave = "valor") {
              if (props.enableEdit === false) return;

              let valores_novo = {...valores};
              if (["escala_diagnostico_pdpe_pfe", "opcoes_diagnostico_pdpe_pfe", "parecer_pdpe_pfe"].includes(configQuestao.tipo)) {
                valores_novo[key] = {
                  ...valores[key],
                  [chave]: valor
                };
              } else {
                valores_novo[key] = valor;
              }
              setValores(valores_novo);
              dirty.current = true;
            }

            function obterValor(key) {
              if (["escala_diagnostico_pdpe_pfe", "opcoes_diagnostico_pdpe_pfe", "parecer_pdpe_pfe"].includes(configQuestao.tipo)) {
                return valores[key] && valores[key].valor;
              }
              return valores[key];
            }

            let key = (etapa.id ? etapa.id + "." : "") + questao.id;

            let inputs = [];

            if (!["OBJETIVOS_PDPE", "OBJETIVOS_PFE"].includes(extra?.tipo) && ['opcoes', "opcoes_diagnostico_pdpe_pfe"].includes(configQuestao.tipo)) {
              inputs.push(<div key={key} className={classes.questaoHeader}>
                <h5>{questao.designacao}</h5>
                {questao.legenda && <p>{questao.legenda}</p>}
                {questao.detalhe && <span className={classes.openInfoButton} onClick={() => {
                  openInfo(questao);
                }}><FontAwesomeIcon icon={faInfoCircle}/></span>}
                {questao.opcoes.map(({valor, designacao}) => {
                  let color = obterValor(key) === valor ? "primary" : "white";
                  if (configQuestao.tipo === "opcoes_diagnostico_pdpe_pfe")
                    color = obterValor(key) === valor ? (valor >= configQuestao._minimo_objetivos ? "primary" : "warning") : "white";

                  return <Button
                    key={key + "_" + valor}
                    color={color}
                    className={obterValor(key) === valor ? classes.nivelButtonActive : classes.nivelButton}
                    onClick={() => guardarValor(key, valor)}>
                    {valor} - {designacao}
                  </Button>
                })}
              </div>)
            }
            if (!["OBJETIVOS_PDPE", "OBJETIVOS_PFE"].includes(extra?.tipo) && ['escala', "escala_diagnostico_pdpe_pfe"].includes(configQuestao.tipo)) {
              inputs.push(<div key={key} className={classes.questaoHeader}>
                <h5>{questao.designacao}</h5>
                {questao.legenda && <p>{questao.legenda}</p>}
                {questao.detalhe && <span className={classes.openInfoButton} onClick={() => {
                  openInfo(questao);
                }}><FontAwesomeIcon icon={faInfoCircle}/></span>}
                <div className={classes.buttonGroup}>
                  {configQuestao.escala.map(({valor, designacao}, idx) => {
                    let color = obterValor(key) === valor ? "primary" : "white";
                    if (configQuestao.tipo === "escala_diagnostico_pdpe_pfe")
                      color = obterValor(key) === valor ? (valor >= configQuestao._minimo_objetivos ? "primary" : "warning") : "white";
                    return <Button
                      color={color}
                      size={"sm"}
                      round={idx === 0 || idx === configQuestao.escala.length - 1}
                      className={({0: classes.firstButton, [configQuestao.escala.length - 1]: classes.lastButton})[idx] || classes.middleButton}
                      onClick={() => guardarValor(key, valor)}>
                      {valor}
                    </Button>
                  })}
                </div>
              </div>);
            }
            if (["OBJETIVOS_PDPE", "OBJETIVOS_PFE", "DIAGNOSTICO_PFE_GENERICO"].includes(extra?.tipo) && ['escala_diagnostico_pdpe_pfe', "opcoes_diagnostico_pdpe_pfe"].includes(configQuestao.tipo)) {
              let ans = obterValor(key);
              let ansStyle = {maxWidth: 86};
              if (ans < configQuestao._minimo_objetivos) {
                ansStyle["backgroundColor"] = "#ffb8a0";
              }
              let colapse = {
                title: <>
                  <span className={"title"}>{questao.designacao}</span>
                </>,
                secondaryTitle: <>
                  <span style={{textTransform: "uppercase", fontSize: 12}}>Resposta: <strong style={{color: ans < configQuestao._minimo_objetivos ? "#F5760D" : undefined}}>{ans}</strong></span>
                  {ans < configQuestao._minimo_objetivos && <span className={"label_obrigatorio"}>Obrigatório</span>}
                </>,
                content: <div>
                  {extra?.tipo !== "DIAGNOSTICO_PFE_GENERICO" && <>
                    <p>{questao.designacao}</p>
                    {questao.detalhe && <span className={classes.openInfoButton} onClick={() => {
                      openInfo(questao);
                    }}><FontAwesomeIcon icon={faInfoCircle}/></span>}
                    <p>Resposta (1 - 5): {ans}</p>
                  </>}
                  <CustomInput
                    labelText="Objetivos"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      type: "text",
                      multiline: true,
                      value: valores[key]?.["objetivos"],
                      rows: 3,
                      onChange: (e) => {
                        guardarValor(key, e.target.value, "objetivos")
                      }
                    }}
                  />
                  <CustomInput
                    labelText="Metas"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      type: "text",
                      multiline: true,
                      value: valores[key]?.["metas"],
                      rows: 3,
                      onChange: (e) => {
                        guardarValor(key, e.target.value, "metas")
                      }
                    }}
                  />
                  <CustomInput
                    labelText="Iniciativas"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      type: "text",
                      multiline: true,
                      value: valores[key]?.["iniciativas"],
                      rows: 3,
                      onChange: (e) => {
                        guardarValor(key, e.target.value, "iniciativas")
                      }
                    }}
                  />
                </div>
              };

              // Diagnóstico genérico não usa accordion
              if (extra?.tipo === "DIAGNOSTICO_PFE_GENERICO") {
                inputs.push(colapse.content);
              } else {
                inputs.push(<Accordion
                  active={(obterValor(key) < configQuestao._minimo_objetivos || valores[key]?.["objetivos"] || valores[key]?.["metas"] || valores[key]?.["iniciativas"]) ? [0] : []}
                  expansionPanelSummaryProps={{className: classes.objetivosAccordionSummary}}
                  expansionPanelProps={{className: classes.objetivosAccordionExpansionPanel}}
                  collapses={[colapse]}
                />);
              }
            }
            if (['data'].includes(configQuestao.tipo)) {
              inputs.push(<div key={key} className={classes.questaoHeader} style={{pointerEvents: props.enableEdit ? '' : "none", marginTop: "20px", marginBottom: "20px"}}>
                <h5>{questao.designacao}</h5>
                {questao.legenda && <p>{questao.legenda}</p>}
                {questao.detalhe && <span className={classes.openInfoButton} onClick={() => {
                  openInfo(questao);
                }}><FontAwesomeIcon icon={faInfoCircle}/></span>}
                <FormControl fullWidth>
                  <Datetime
                    inputProps={{placeholder: "Escolha a data e hora da investidura"}}
                    value={valores[key]}
                    onChange={(e) => {
                      guardarValor(key, e)
                    }}
                    dateFormat={"DD/MM/YYYY"}
                    timeFormat={"H:mm"}
                    defaultValue={valores[key]}
                  />
                </FormControl>
              </div>);
            }
            if (['texto'].includes(configQuestao.tipo)) {
              inputs.push(<div key={key} className={classes.questaoHeader} style={{marginBottom: "130px"}}>
                <h5>{questao.designacao}</h5>
                {questao.legenda && <p>{questao.legenda}</p>}
                {questao.detalhe && <span className={classes.openInfoButton} onClick={() => {
                  openInfo(questao);
                }}><FontAwesomeIcon icon={faInfoCircle}/></span>}
                <CustomInput
                  formControlProps={{
                    fullWidth: true,
                    style: {marginTop: 0, paddingTop: 0}
                  }}
                  inputProps={{
                    type: "text",
                    multiline: true,
                    value: valores[key],
                    rows: 5,
                    onChange: (e) => {
                      guardarValor(key, e.target.value)
                    }
                  }}
                />
              </div>);
            }
            if (["PARECER_PDPE", "PARECER_PFE"].includes(extra?.tipo) && ['parecer_pdpe_pfe'].includes(configQuestao.tipo)) {
              if (!valores[key]) return null;

              let ans = obterValor(key);

              inputs.push(<>
                {questao.detalhe && <span className={classes.openInfoButton} onClick={() => {
                  openInfo(questao);
                }}><FontAwesomeIcon icon={faInfoCircle}/></span>}
                <h4>{questao.designacao}</h4>
                <p><span style={{textTransform: "uppercase"}}><strong>Resposta:</strong></span><br/><strong style={{color: ans < configQuestao._minimo_objetivos ? "#F5760D" : undefined}}>{ans}</strong></p>
                {valores[key]?.["objetivos"] && <p><span style={{textTransform: "uppercase"}}><strong>Objetivos:</strong></span><br/>{valores[key]?.["objetivos"]}</p>}
                {valores[key]?.["metas"] && <p><span style={{textTransform: "uppercase"}}><strong>Metas:</strong></span><br/>{valores[key]?.["metas"]}</p>}
                {valores[key]?.["iniciativas"] && <p><span style={{textTransform: "uppercase"}}><strong>Iniciativas:</strong></span><br/>{valores[key]?.["iniciativas"]}</p>}
                <div>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={valores[key]?.["cumpriu"]}
                        tabIndex={-1}
                        onClick={() => {
                          guardarValor(key, !valores[key]?.["cumpriu"], "cumpriu")
                        }}
                        checkedIcon={<Check className={classes.checkedIcon}/>}
                        icon={<Check className={classes.uncheckedIcon}/>}
                        classes={{
                          checked: classes.checked
                        }}
                      />
                    }
                    classes={{
                      label: classes.label
                    }}
                    label={"O candidato cumpriu os objetivos propostos"}
                  />
                  <CustomInput
                    labelText="Parecer"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      type: "text",
                      multiline: true,
                      value: valores[key]?.["parecer"],
                      rows: 3,
                      onChange: (e) => {
                        guardarValor(key, e.target.value, "parecer")
                      }
                    }}
                  />
                </div>
              </>);
            }

            if (extra?.tipo === "DIAGNOSTICO_PFE_GENERICO") {
              return <div style={{border: "1px solid #ddd", padding: 20, marginBottom: 20, borderRadius: 5}}>
                {inputs}
              </div>
            }

            return inputs;
          })}
        </div>
      </div>)
    })
  });


  return <>
    {modal}
    <NavPills
      classes={{
        //swipeableViews: classes.swipeableViews
      }}
      alignCenter={true}
      color="primary"
      tabs={content}
      active={etapa}
      onChange={setEtapa}
    />
    <div className={classes.navegacao}>
      {etapa !== 0 ? (
        <Button
          color="info"
          className={classes.buttonAnterior}
          onClick={prevNav}
        >Anterior</Button>) : null}
      {etapa !== (formulario.etapas.length - 1) ? (
        <Button
          color="info"
          className={classes.buttonAnterior}
          onClick={nextNav}
        >Seguinte</Button>) : null}

      <div className={classes.actions}>
        {props.enableSubmit !== false && <Button
          color="success"
          className={classes.buttonSeguinte}
          onClick={submitAnswers}
        >Submeter</Button>}
        {props.enableSave !== false && <Button
          color="info"
          className={classes.buttonSeguinte}
          onClick={() => props.onSave && props.onSave(valores)}
        >Guardar</Button>}
        {props.actions && props.actions.map(a => <Button
          color={a.color}
          onClick={a.onClick}
        >{a.label}</Button>)}
      </div>
    </div>
  </>
}

export default withStyles(feedbackStyle)(FormularioGenerico);
